import { CostCentersDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllCostCentersResponseModel extends GlobalResponseObject {
    data?: CostCentersDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: CostCentersDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    } 
}

